import React from 'react';
import { AIE_CARDS } from './homeContent';
import './HomeFeatureCards.css';

/**
 * HomeFeatureCards — the six AI-employee promises as quiet cards, inside
 * section 01 (replaced the check-bullet list, Aug 28 2026 — Nitish's pick:
 * Option A, 3x2 desktop / 2 across tablet+phone).
 *
 * Copy lives in homeContent.AIE_CARDS (the canon content layer) — never
 * hardcode a card string here. Icons are hand-drawn single-stroke marks in the
 * demo-frame lineage; stroke color comes from CSS (the accent token), so both
 * theme faces get the right teal with no per-face markup.
 */
const ICONS = {
  clock: (
    <>
      <circle cx="12" cy="12.6" r="8.4" />
      <path d="M12 8.1v4.5l3.2 1.9" />
      <path d="M9.2 2.6h5.6" />
    </>
  ),
  memory: (
    <>
      <rect x="4.2" y="4.2" width="15.6" height="15.6" rx="3.4" />
      <rect x="8.6" y="8.6" width="6.8" height="6.8" rx="1.6" />
      <path d="M8.6 2.8v1.4M15.4 2.8v1.4M8.6 19.8v1.4M15.4 19.8v1.4M2.8 8.6h1.4M2.8 15.4h1.4M19.8 8.6h1.4M19.8 15.4h1.4" />
    </>
  ),
  inbox: (
    <>
      <rect x="3.2" y="5.2" width="17.6" height="13.6" rx="2.6" />
      <path d="M3.9 7.1l7.3 5.4a1.4 1.4 0 001.6 0l7.3-5.4" />
    </>
  ),
  tools: (
    <path d="M14.1 3.6a4.6 4.6 0 00-6 6L4.4 13.3a2.1 2.1 0 000 3l3.3 3.3a2.1 2.1 0 003 0l3.7-3.7a4.6 4.6 0 006-6l-2.9 2.9-2.2-.6-.6-2.2z" />
  ),
  control: (
    <>
      <path d="M12 3.1l7.3 2.6c.2 5.9-2.4 11-7.3 13.3-4.9-2.3-7.5-7.4-7.3-13.3z" />
      <path d="M8.9 11.6l2.3 2.3 4.1-4.6" />
    </>
  ),
  report: (
    <>
      <path d="M6 3.4h7.6l4.4 4.4v12.8H6z" />
      <path d="M13.4 3.5v4.4h4.4" />
      <path d="M9.1 12.3h5.8M9.1 15.6h4" />
    </>
  ),
};

const HomeFeatureCards = () => (
  <div className="home-cards" role="list">
    {AIE_CARDS.map((c) => (
      <div className="home-card" role="listitem" key={c.title}>
        <svg className="home-card__ico" viewBox="0 0 24 24" aria-hidden="true">
          {ICONS[c.icon]}
        </svg>
        <h3 className="home-card__t">{c.title}</h3>
        <p className="home-card__p">{c.body}</p>
      </div>
    ))}
  </div>
);

export default HomeFeatureCards;
